import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLetterBottom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 280,
	height: 182,
	viewBox: "0 0 280 182",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M280 181.982V0.754517L0 181.982H280Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 181.982V0.754517L280 181.982H0Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.282 181.982H1.71802L132.623 85.2254C137.007 81.985 142.993 81.985 147.377 85.2254L278.282 181.982Z",
			fill: "#A7C4FC"
		})
	]
});
export default SvgLetterBottom;
